const localStoreUtil = {
  store_data: (key, data) => {
    if (typeof data === "object") {
      sessionStorage.setItem(key, JSON.stringify(data));
    } else {
      sessionStorage.setItem(key, data);
    }

    return true;
  },

  get_data: (key) => {
    const item = sessionStorage.getItem(key);
    if (!item) return;
    return item;
  },

  remove_data: (key) => {
    sessionStorage.removeItem(key);
    return true;
  },

  remove_all: () => {
    sessionStorage.clear();
    return true;
  },
};

export default localStoreUtil;
